/**
 * Column widths shared by the staff tables. The name column leads every row: it keeps a generous
 * minimum and rarely wraps at 1440 px, while secondary free text (inputs, steps, errors, reasons)
 * clamps inside `CellText` and gives way first.
 */
export const NAME_MIN_WIDTH = '16rem';
export const NAME_MAX_WIDTH = '26rem';
